import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
export default {
  name: 'd2-button',
  render: function render() {
    var h = arguments[0];
    var button = h("el-button", {
      "attrs": _objectSpread({}, this.$attrs),
      "class": {
        'd2-button': true,
        'is-thin': this.thin
      },
      "style": this.block ? {
        width: '100%'
      } : {},
      "on": {
        "click": this.onClick
      }
    }, [this.fa ? h("d2-icon", {
      "attrs": {
        "name": this.fa
      }
    }) : undefined, this.fa && (this.label || this.$slots.default) ? ' ' : undefined, this.label ? this.label : undefined, this.$slots.default]);
    return button;
  },
  props: {
    fa: {
      type: String,
      default: '',
      required: false
    },
    label: {
      type: String,
      default: '',
      required: false
    },
    to: {
      type: [String, Object],
      default: '',
      required: false
    },
    block: {
      type: Boolean,
      default: false,
      required: false
    },
    thin: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  methods: {
    onClick: function onClick(e) {
      if (this.to) {
        this.$router.push(this.to);
      }

      this.$emit('click', e);
    }
  }
};